import { Injectable } from '@angular/core';

import { GridCol } from '../../model/asd/asd-properties/asd-grid';
import { GridBase, GridRow, GridColumn } from '../../model/grid/grid';
import { FormBase } from '../../model/form/form';
import { ViewArea } from '../../model/asd/asd-properties/asd-viewArea';
import { AsdBase } from '../../model/asd/asd';

import { FormInit } from '../../model/form/form-properties/form-init';
import { ASDTypes } from '../../model/asd/asd-properties/asd-type';
import { InterfaceElementTypes } from '../../model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { InterfaceElement, IEDisplayProperties } from '../../model/asd/asd-properties/asd-ie/asd-interfaceElement';

import { CosyAppStateDataControllerService } from '../controller/cosy-app-state-data-controller.service';
import { CosyHtmlElementGenerationService } from '../generator/generator-html/cosy-html-element-generation.service';



@Injectable()
export class CosyInitializationService {
 
  private asd: AsdBase;
  private tasd: AsdBase;
  private dd: AsdBase;
  private casd: AsdBase;
  private mess: any;
  private cosyDocuments: any[] = [];

  constructor(
    private cosyAppStateDataControllerService: CosyAppStateDataControllerService,
    private cosyHtmlElementGenerationService: CosyHtmlElementGenerationService
  ) {}

  initializeCosyAppState(uxformControlMatrices, cosyDocs: any[]) {
    let gridRows: GridRow[] = [];
    let uxControllerProperties = new FormBase();
    let cosyFormInit = new FormInit();
    let cosyDocType: string;
    let ieListFromTemplate: InterfaceElement[] = [];
    this.cosyDocuments = cosyDocs;
    
    for (let c of cosyDocs) {
      cosyDocType = this.cosyAppStateDataControllerService.getDocType(c);
      if (cosyDocType == ASDTypes.ASD) {
        this.asd = c['CosyDocument'];
      } else if (cosyDocType == ASDTypes.CASD) {
        if (this.asd != null && this.asd.Header.AppStateID == c['CosyDocument'].Header.AppStateID) {
          this.casd = c['CosyDocument'];
        }
      } else if (cosyDocType == ASDTypes.DD) {
        if (this.asd != null && this.asd.Header.AppStateID == c['CosyDocument'].Header.AppStateID) {
          this.dd = c['CosyDocument'];
        }
      } else if (cosyDocType == ASDTypes.TASD) {
        this.tasd = c['CosyDocument'];
      } else if (cosyDocType == 'MessagesDocument') {
        this.mess = c['CosyDocument'];
      }
    }
  
    if (uxformControlMatrices != null && uxformControlMatrices.length > 0) {
      uxControllerProperties.FormStates = uxformControlMatrices[0].formStateMatrix;
      uxControllerProperties.FormTransitions = uxformControlMatrices[0].formTransitionMatrix;
      uxControllerProperties.FormMessages = uxformControlMatrices[0].formTransitionMessages;
      let elementIn: boolean = false;
      this.mess.FormTransitionMessages.forEach(elementNM => {
        uxControllerProperties.FormMessages.forEach(element => {
          if (element.messageID === elementNM.messageID){
            elementIn = true;
          }
        });
        if (!elementIn) uxControllerProperties.FormMessages.push(elementNM);
        elementIn = false;
      });
    }
    else uxControllerProperties.FormMessages = this.mess.FormTransitionMessages;
    

    cosyFormInit.Header = this.asd.Header;
    cosyFormInit.ViewAreaList = this.asd.ViewAreas;
    cosyFormInit.UXControllerProperties = uxControllerProperties;

    cosyFormInit.DesignDocument = this.dd;
    cosyFormInit.CustomAppStateDocument = this.casd;
    cosyFormInit.TemplateAppStateDocument = this.tasd;

    cosyFormInit = this.filterAndPreSetIEAttributes(cosyFormInit);

    if (this.tasd != null) {
      ieListFromTemplate = this.tasd.InterfaceElements;

      let templateRows = this.tasd.Grid.GridLayout.RowDefs;
      for (let trow of templateRows) {
        for (let tcol of trow.Cols) {
          this.generateGridView(tcol, cosyFormInit.ViewAreaList, ieListFromTemplate);
        }
      }
    } else {
      for (let va of cosyFormInit.ViewAreaList) {
        let gridRow = new GridRow();
        let gridColumn = new GridColumn();
        let gridColumnns: GridColumn[] = [];

        gridColumn.ColumnID = va.ViewAreaGridLayout.GridColumnID;
        gridColumn.InterfaceElements = va.InterfaceElements;
        gridColumnns.push(gridColumn);

        gridRow = this.verifyGridExistance(gridRows, va.ViewAreaGridLayout.GridRowID);

        if (Object.keys(gridRow).length !== 0) {
          gridRow.Columns.push(gridColumn);
        } else {
          gridRow.RowID = va.ViewAreaGridLayout.GridRowID;
          gridRow.Columns = gridColumnns;
          gridRows.push(gridRow);
        }
      }
      cosyFormInit.GridRows = gridRows;
    }
    return cosyFormInit;
  }

  generateGridView(col: GridCol, viewAreaList: ViewArea[], ieList: InterfaceElement[]) {
    let ieListFromTemplate = this.tasd.InterfaceElements;
    for (var va of viewAreaList) {
      if (col.ColViewAreaTemplateID == va.ViewAreaTemplateID) {
        col.InterfaceElements = va.InterfaceElements;
      }
    }
    if (col.InterfaceElements.length == 0) {
      col.ColWidth = '';
    } else {
      this.setGridAttribute(col.InterfaceElements, ieList);
    }
  }

  setGridAttribute(toIEs: InterfaceElement[], fromIEs: InterfaceElement[]) {
    for (let frmIE of fromIEs) {
      for (let toIE of toIEs) {
        if (frmIE.TemplateID == toIE.TemplateID) {
          toIE.Attributes.AssignedColumnWidth = frmIE.Attributes.AssignedColumnWidth;
          if (frmIE.Attributes.Visible != null) toIE.Attributes.Visible = frmIE.Attributes.Visible; //Logik??? TWI
        }
        if(toIE.TypeDID == InterfaceElementTypes.Ribbon && toIE.InterfaceElements.length>0){
          for(let tiee of toIE.InterfaceElements){
            if(tiee.TemplateID == frmIE.TemplateID){
              tiee.Attributes.AssignedColumnWidth = frmIE.Attributes.AssignedColumnWidth;
            }
          }
        }
      }
    }
  }

  filterAndPreSetIEAttributes(cosyFormInit: FormInit) {
    let filteredInterfaceEements: InterfaceElement[] = [];
    let filteredViewAreas: ViewArea[] = [];
    let csieList: InterfaceElement[] = [];
    
    if (cosyFormInit.CustomAppStateDocument != null) {
      //csieList = cosyFormInit.CustomAppStateDocument.InterfaceElements; // Custom kommt vom Server
    }

    for (let va of cosyFormInit.ViewAreaList) {
    
      if (va.Attributes.Visible && va.InterfaceElements.length > 0) {
        
        this.updateViewAreaInterfaceElements(va, csieList);

        for (let ie of va.InterfaceElements) {
          if(ie.TypeDID == InterfaceElementTypes.Ribbon){
            for(let iee of ie.InterfaceElements){
              if ((iee.TypeDID == InterfaceElementTypes.UXController || iee.TypeDID == InterfaceElementTypes.ListUXController) 
              && iee.Attributes.Visible) {
                cosyFormInit.UXControllerProperties.FormValidUAID = iee.Attributes.ValidUAID;
                cosyFormInit.UXControllerProperties.FormInvalidUAID = iee.Attributes.InvalidUAID;
                cosyFormInit.UXControllerProperties.FormCurrentState = iee.Values.length > 0 ? iee.Values[0].Value : '';
                cosyFormInit.UXControllerProperties.FormActivateOnIE = iee.Attributes.ActivateOnIE;
              }
            }
          }
          if ((ie.TypeDID == InterfaceElementTypes.UXController || ie.TypeDID == InterfaceElementTypes.ListUXController) 
              && ie.Attributes.Visible) {
            cosyFormInit.UXControllerProperties.FormValidUAID = ie.Attributes.ValidUAID;
            cosyFormInit.UXControllerProperties.FormInvalidUAID = ie.Attributes.InvalidUAID;
            cosyFormInit.UXControllerProperties.FormCurrentState = ie.Values.length > 0 ? ie.Values[0].Value : '';
            cosyFormInit.UXControllerProperties.FormActivateOnIE = ie.Attributes.ActivateOnIE;
          }

          if (ie.Attributes.DisplayOrder == null) {
            ie.Attributes.DisplayOrder = 1000;
          }

          filteredInterfaceEements.push(ie);
        }

        filteredInterfaceEements = this.cosyAppStateDataControllerService.updateUIObjectsOfIE(
          filteredInterfaceEements,
          cosyFormInit.UXControllerProperties,
          true,
          cosyFormInit.DesignDocument
        );

        filteredInterfaceEements = this.cosyHtmlElementGenerationService.updateCustomizedFormats(filteredInterfaceEements, cosyFormInit.ViewAreaList);
        va.InterfaceElements = filteredInterfaceEements;
        filteredInterfaceEements = [];
        filteredViewAreas.push(va);
      }
    }

    cosyFormInit.ViewAreaList = filteredViewAreas;
    return cosyFormInit;
  }

  updateViewAreaInterfaceElements(va: ViewArea, cieList: InterfaceElement[]) {
    
    let IEPerTabList: InterfaceElement[] = [];
    let finalTabsIEList: InterfaceElement[] = [];
    let indexToRemove: number[] = [];
   
    for (let vie of va.InterfaceElements) {
      if (vie.Attributes.DisplayOrder == null) {
        vie.Attributes.DisplayOrder = 1000;
      }

      if (vie.Attributes.GroupID != null) {
        IEPerTabList.push(vie);
        const index = va.InterfaceElements.indexOf(vie);
        indexToRemove.push(index);
      }
      if (vie.TypeDID == InterfaceElementTypes.Tab) {
        if (IEPerTabList.length > 0) {
          finalTabsIEList = vie.InterfaceElements.concat(IEPerTabList);
          vie.InterfaceElements = finalTabsIEList;
        }
      }
      if(vie.TypeDID == InterfaceElementTypes.Ribbon){
        vie.InterfaceElements.sort((a, b) => a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
      }

      /*set DisplayLabel for IEs*/
     /* vie = this.updateDisplayPropsOfIE(vie);
      if(vie.InterfaceElements!= null && vie.InterfaceElements.length>0){
        for(let viee of vie.InterfaceElements){
          viee = this.updateDisplayPropsOfIE(viee);
        }
      }*/
    }
    va.InterfaceElements.sort((a, b) => a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);

    for (var i = indexToRemove.length - 1; i >= 0; i--) {
      va.InterfaceElements.splice(indexToRemove[i], 1);
    }
  }

  getInterfaceElementByID(ieList: InterfaceElement[], refIE: String): InterfaceElement {
    let ieIEReturn: InterfaceElement = null; 
    ieList.forEach(ieIE => {
      let ieIEHelp: InterfaceElement = null; 
      if (ieIEReturn == null && ieIE.InterfaceElementID == refIE) ieIEReturn = ieIE;
      if (ieIEReturn == null && ieIE.InterfaceElements != null) ieIEHelp = this.getInterfaceElementByID(ieIE.InterfaceElements, refIE);
      if (ieIEReturn == null && ieIEHelp != null) ieIEReturn = ieIEHelp;
    })
    return ieIEReturn;
  }  

  verifyGridExistance(gridRows: GridRow[], rowId: number) {
    let gridRow = new GridRow();
    for (let gr of gridRows) {
      if (gr.RowID == rowId) {
        gridRow = gr;
      }
    }
    return gridRow;
  }

 /* updateDisplayPropsOfIE(ie: InterfaceElement){
    ie.DisplayProperties = new IEDisplayProperties();
    if(ie.PreLabel!=null){
      ie.DisplayProperties.DisplayName = ie.PreLabel.DisplayName;
      ie.DisplayProperties.DisplaySrcKey = "PreLabel";
    } else if(ie.Label!=null){
      ie.DisplayProperties.DisplayName = ie.Label.DisplayName;
      ie.DisplayProperties.DisplaySrcKey = "Label"
    } else if(ie.Name!=null){
      ie.DisplayProperties.DisplayName = ie.Name;
      ie.DisplayProperties.DisplaySrcKey = "Name";
    }
    return ie;
  }*/
}
